import { GlyphType } from '../Icon';

export type RouteType = {
  id: string;
  icon: GlyphType;
  path?: string;
  paths?: any;
  exact?: boolean;
  name: string;
  iconAttributes?: Record<string, any>;
};

export const helpOptions: RouteType[] = [
  {
    id: 'FAQ',
    icon: 'help',
    path: 'https://support.freshsurvey.io/en/support/solutions/50000000181',
    name: 'settings.help_option.faq',
    exact: true,
  },
  {
    id: 'Support portal',
    icon: 'help',
    path: 'https://support.freshsurvey.io/en/support/home',
    name: 'settings.help_option.support_portal',
  },
  {
    id: 'Contact us',
    icon: 'help',
    path: 'https://support.freshsurvey.io/en/support/tickets/new',
    name: 'settings.help_option.contact_us',
  },
  {
    id: 'Privacy policy',
    icon: 'help',
    path: 'https://www.freshworks.com/privacy/',
    name: 'settings.help_option.privacy_policy',
  },
  {
    id: 'System status',
    icon: 'help',
    path: 'https://status.freshsurvey.io',
    name: 'settings.help_option.system_status',
  },
];

export const routes: RouteType[] = [
  {
    id: 'dashboard',
    icon: 'compass',
    path: '/dashboard',
    name: 'sidebar.dashboard',
  },
  {
    id: 'survey',
    icon: 'survey',
    path: '/survey',
    name: 'sidebar.surveys',
  },
  {
    id: 'response',
    icon: 'response',
    name: 'sidebar.responses',
    path: '/response',
    // paths: [
    //   {
    //     id: 'responses',
    //     name: 'Responses',
    //     path: '/response',
    //   },
    //   {
    //     id: 'queue',
    //     name: 'Queue',
    //     path: '/queue',
    //   },
    // ],
  },
  {
    id: 'contact',
    name: 'Contact Management',
    icon: 'contact',
    paths: [
      {
        id: 'contacts',
        name: 'sidebar.contacts.all_contacts',
        path: '/contacts',
      },
      {
        id: 'segments',
        name: 'sidebar.contacts.segments',
        path: '/segments',
      },
      {
        id: 'lists',
        name: 'sidebar.contacts.lists',
        path: '/lists',
      },
    ],
  },
  {
    id: 'workflow',
    icon: 'workflow',
    path: '/workflow',
    name: 'sidebar.workflows',
    // its needed since the animation involves shape rotate and the path is clipped without extra space around it
    iconAttributes: { viewBox: '-2 -2 24 24', fill: '#fff' },
  },
  {
    id: 'analytics',
    icon: 'chart',
    path: '/analytics',
    name: 'sidebar.analytics',
  },
  {
    id: 'settings',
    icon: 'settings',
    path: '/settings',
    name: 'sidebar.settings',
  },
];
